<!--
 * @Author: Bai YanShuo
 * @Date: 2023-11-08 13:58:31
 * @LastEditors: Bai YanShuo
 * @LastEditTime: 2023-11-09 17:15:20
 * @FilePath: /web/src/views/we-work/index.vue
 * @Description:
-->
<template>
  <div>
    redirecting
  </div>
</template>

<script>
export default {
  name: 'WeWork',
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
